import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=1ee12dbe&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=1ee12dbe&prod&scoped=true&lang=css"
import style1 from "./DropdownItem.vue?vue&type=style&index=1&id=1ee12dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee12dbe",
  null
  
)

export default component.exports